import { Navigate } from 'react-router-dom';
import { useAuth } from '../../store/AuthContext';
import { JSX } from 'react';

export default function AdminRoute({ children }: { children: JSX.Element }) {
  const { user } = useAuth();

  if (!user || user.role !== 'Admin') {
    return <Navigate to="/dashboard" />;
  }

  return children;
}